import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8be7886c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-5 container" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-arrow-left" }, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_5024_2910)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M2.5 18.625C2.5 19.1223 2.69754 19.5992 3.04917 19.9508C3.40081 20.3025 3.87772 20.5 4.375 20.5H15.625C16.1223 20.5 16.5992 20.3025 16.9508 19.9508C17.3025 19.5992 17.5 19.1223 17.5 18.625V5.50001H2.5V18.625ZM13.125 8.62501C13.125 8.45925 13.1908 8.30028 13.3081 8.18306C13.4253 8.06585 13.5842 8.00001 13.75 8.00001C13.9158 8.00001 14.0747 8.06585 14.1919 8.18306C14.3092 8.30028 14.375 8.45925 14.375 8.62501V17.375C14.375 17.5408 14.3092 17.6997 14.1919 17.8169C14.0747 17.9342 13.9158 18 13.75 18C13.5842 18 13.4253 17.9342 13.3081 17.8169C13.1908 17.6997 13.125 17.5408 13.125 17.375V8.62501ZM9.375 8.62501C9.375 8.45925 9.44085 8.30028 9.55806 8.18306C9.67527 8.06585 9.83424 8.00001 10 8.00001C10.1658 8.00001 10.3247 8.06585 10.4419 8.18306C10.5592 8.30028 10.625 8.45925 10.625 8.62501V17.375C10.625 17.5408 10.5592 17.6997 10.4419 17.8169C10.3247 17.9342 10.1658 18 10 18C9.83424 18 9.67527 17.9342 9.55806 17.8169C9.44085 17.6997 9.375 17.5408 9.375 17.375V8.62501ZM5.625 8.62501C5.625 8.45925 5.69085 8.30028 5.80806 8.18306C5.92527 8.06585 6.08424 8.00001 6.25 8.00001C6.41576 8.00001 6.57473 8.06585 6.69194 8.18306C6.80915 8.30028 6.875 8.45925 6.875 8.62501V17.375C6.875 17.5408 6.80915 17.6997 6.69194 17.8169C6.57473 17.9342 6.41576 18 6.25 18C6.08424 18 5.92527 17.9342 5.80806 17.8169C5.69085 17.6997 5.625 17.5408 5.625 17.375V8.62501ZM18.125 1.75001H13.4375L13.0703 1.01954C12.9925 0.863372 12.8727 0.732008 12.7243 0.640225C12.576 0.548442 12.4049 0.499882 12.2305 0.500007H7.76562C7.59155 0.499338 7.42082 0.547717 7.27297 0.639602C7.12513 0.731487 7.00615 0.863161 6.92969 1.01954L6.5625 1.75001H1.875C1.70924 1.75001 1.55027 1.81585 1.43306 1.93307C1.31585 2.05028 1.25 2.20925 1.25 2.37501L1.25 3.62501C1.25 3.79077 1.31585 3.94974 1.43306 4.06695C1.55027 4.18416 1.70924 4.25001 1.875 4.25001H18.125C18.2908 4.25001 18.4497 4.18416 18.5669 4.06695C18.6842 3.94974 18.75 3.79077 18.75 3.62501V2.37501C18.75 2.20925 18.6842 2.05028 18.5669 1.93307C18.4497 1.81585 18.2908 1.75001 18.125 1.75001Z" })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_5024_2910" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "20",
        height: "20",
        fill: "currentColor",
        transform: "translate(0 0.5)"
      })
    ])
  ])
], -1))
const _hoisted_7 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "row m-0 p-0" }
const _hoisted_20 = {
  class: /*#__PURE__*/_normalizeClass(['container-info d-flex flex-column gap-3 p-0', 'col-12']),
  style: {"transition":"all 0.3s ease-out"}
}
const _hoisted_21 = { class: "card card-info-cliente col-12" }
const _hoisted_22 = { class: "d-flex gap-4 p-5 align-items-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-3 rounded",
  style: {"background-color":"#f9f9f9"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M15.0002 21H6.00016V13.5H3.00016V25.5C3.00016 26.3297 3.67048 27 4.50016 27H16.5002C17.3299 27 18.0002 26.3297 18.0002 25.5V13.5H15.0002V21ZM29.747 9.66562L25.7486 3.66562C25.4674 3.24844 24.9986 3 24.497 3H5.50329C5.00173 3 4.53298 3.24844 4.25641 3.66562L0.257976 9.66562C-0.407649 10.6641 0.304851 12 1.50485 12H28.5002C29.6955 12 30.408 10.6641 29.747 9.66562ZM24.0002 26.25C24.0002 26.6625 24.3377 27 24.7502 27H26.2502C26.6627 27 27.0002 26.6625 27.0002 26.25V13.5H24.0002V26.25Z",
      fill: "#203972"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M29.7469 9.66562L25.7484 3.66562C25.4672 3.24844 24.9984 3 24.4969 3H5.50311C5.00154 3 4.53279 3.24844 4.25623 3.66562L0.257793 9.66562C-0.407832 10.6641 0.304668 12 1.50467 12H28.5C29.6953 12 30.4078 10.6641 29.7469 9.66562Z",
      fill: "#203972"
    })
  ])
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-5" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_25 = {
  key: 0,
  class: "p-5"
}
const _hoisted_26 = { class: "row mb-1" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "d-flex flex-column gap-1" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CNPJ:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3980_226)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M19.7266 17.793L15.832 13.8984C15.6562 13.7227 15.418 13.625 15.168 13.625H14.5312C15.6094 12.2461 16.25 10.5117 16.25 8.625C16.25 4.13672 12.6133 0.5 8.125 0.5C3.63672 0.5 0 4.13672 0 8.625C0 13.1133 3.63672 16.75 8.125 16.75C10.0117 16.75 11.7461 16.1094 13.125 15.0312V15.668C13.125 15.918 13.2227 16.1562 13.3984 16.332L17.293 20.2266C17.6602 20.5938 18.2539 20.5938 18.6172 20.2266L19.7227 19.1211C20.0898 18.7539 20.0898 18.1602 19.7266 17.793ZM8.125 13.625C5.36328 13.625 3.125 11.3906 3.125 8.625C3.125 5.86328 5.35938 3.625 8.125 3.625C10.8867 3.625 13.125 5.85938 13.125 8.625C13.125 11.3867 10.8906 13.625 8.125 13.625Z",
      fill: "#ED2B46"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3980_226" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(0 0.5)"
      })
    ])
  ])
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "d-flex flex-column gap-1" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loja (Nome Fantasia):", -1))
const _hoisted_35 = { class: "row mb-1" }
const _hoisted_36 = { class: "col" }
const _hoisted_37 = { class: "d-flex flex-column gap-1" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gerente:", -1))
const _hoisted_39 = { class: "col" }
const _hoisted_40 = { class: "d-flex flex-column gap-1" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Solicitante:", -1))
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "d-flex flex-column gap-1" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Contato:", -1))
const _hoisted_45 = {
  key: 0,
  class: "row mb-1"
}
const _hoisted_46 = { class: "col" }
const _hoisted_47 = { class: "d-flex flex-column gap-1" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Automação:", -1))
const _hoisted_49 = { class: "col" }
const _hoisted_50 = { class: "d-flex flex-column gap-1" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Possui Conecta?:", -1))
const _hoisted_52 = {
  key: 1,
  class: "card p-4"
}
const _hoisted_53 = { class: "card card-info-problema col-12" }
const _hoisted_54 = { class: "d-flex gap-4 p-5 align-items-center" }
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<div class=\"p-3 rounded\" style=\"background-color:#f9f9f9;\" data-v-8be7886c><svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-8be7886c><g clip-path=\"url(#clip0_4001_313)\" data-v-8be7886c><path opacity=\"0.5\" d=\"M29.9993 16.9277C29.9713 17.949 29.1076 18.75 28.086 18.75H24.8437V19.6875C24.8437 20.9686 24.5577 22.1827 24.0468 23.2702L27.5758 26.7992C28.308 27.5314 28.308 28.7186 27.5758 29.4509C26.8435 30.1831 25.6564 30.183 24.9241 29.4509L21.7169 26.2437C20.2667 27.4198 18.419 28.125 16.4062 28.125V13.8281C16.4062 13.4398 16.0914 13.125 15.7031 13.125H14.2968C13.9085 13.125 13.5937 13.4398 13.5937 13.8281V28.125C11.581 28.125 9.73321 27.4198 8.28301 26.2437L5.07582 29.4509C4.34352 30.1831 3.15635 30.183 2.42411 29.4509C1.69192 28.7186 1.69192 27.5314 2.42411 26.7992L5.95309 23.2702C5.44227 22.1827 5.15622 20.9686 5.15622 19.6875V18.75H1.91399C0.892348 18.75 0.0287341 17.949 0.000726326 16.9277C-0.0283948 15.8681 0.821918 15 1.87496 15H5.15622V11.5579L2.42411 8.8258C1.69192 8.09355 1.69192 6.90639 2.42411 6.17414C3.15641 5.44189 4.34352 5.44189 5.07582 6.17414L8.27663 9.375H21.7232L24.924 6.1742C25.6564 5.44195 26.8435 5.44195 27.5758 6.1742C28.308 6.90645 28.308 8.09361 27.5758 8.82586L24.8437 11.5579V15H28.125C29.178 15 30.0283 15.8681 29.9993 16.9277ZM15.0586 0C11.4342 0 8.49606 2.93812 8.49606 6.5625H21.6211C21.6211 2.93812 18.6829 0 15.0586 0Z\" fill=\"#203972\" data-v-8be7886c></path><path d=\"M29.9993 16.9278C29.9713 17.9491 29.1076 18.75 28.086 18.75H24.8437V19.6875C24.8437 20.9686 24.5577 22.1827 24.0468 23.2703L27.5758 26.7992C28.308 27.5315 28.308 28.7187 27.5758 29.4509C26.8435 30.1831 25.6564 30.1831 24.9241 29.4509L21.7169 26.2437C20.2667 27.4199 18.419 28.125 16.4062 28.125V13.8282C16.4062 13.4399 16.0914 13.125 15.7031 13.125H14.2968C13.9085 13.125 13.5937 13.4399 13.5937 13.8282V28.125C11.581 28.125 9.73321 27.4199 8.28301 26.2437L5.07582 29.4509C4.34352 30.1831 3.15635 30.1831 2.42411 29.4509C1.69192 28.7187 1.69192 27.5315 2.42411 26.7992L5.95309 23.2703C5.44227 22.1827 5.15621 20.9686 5.15621 19.6875V18.75H1.91399C0.892348 18.75 0.0287341 17.9491 0.000726326 16.9278C-0.0283948 15.8682 0.821918 15 1.87496 15H5.15621V11.558L2.42411 8.82584C1.69192 8.0936 1.69192 6.90643 2.42411 6.17418C3.15641 5.44194 4.34352 5.44194 5.07582 6.17418L8.27662 9.37504H21.7232L24.924 6.17424C25.6564 5.442 26.8435 5.442 27.5758 6.17424C28.308 6.90649 28.308 8.09366 27.5758 8.8259L24.8437 11.558V15H28.125C29.178 15 30.0283 15.8682 29.9993 16.9278Z\" fill=\"#203972\" data-v-8be7886c></path></g><defs data-v-8be7886c><clipPath id=\"clip0_4001_313\" data-v-8be7886c><rect width=\"30\" height=\"30\" fill=\"white\" data-v-8be7886c></rect></clipPath></defs></svg></div>", 1)
const _hoisted_56 = { class: "d-flex flex-row justify-content-between w-100" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-5" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted m-0" })
], -1))
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "p-5" }
const _hoisted_60 = { class: "d-flex flex-column gap-1" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Selecione uma categoria:", -1))
const _hoisted_62 = {
  key: 0,
  class: "d-flex flex-column gap-1"
}
const _hoisted_63 = { class: "d-flex flex-column gap-1" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Status:", -1))
const _hoisted_65 = { class: "d-flex flex-column gap-1" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "E-mail: ", -1))
const _hoisted_67 = {
  key: 0,
  class: "p-4 d-flex flex-row flex-wrap"
}
const _hoisted_68 = { class: "col-6 mb-2 p-2" }
const _hoisted_69 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_70 = { class: "col-6 mb-2 p-2" }
const _hoisted_71 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_72 = { class: "col-6 mb-2 p-2" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "E-mail: ", -1))
const _hoisted_74 = {
  key: 1,
  class: "p-5"
}
const _hoisted_75 = { class: "row mb-1" }
const _hoisted_76 = { class: "col" }
const _hoisted_77 = { class: "d-flex flex-column gap-1" }
const _hoisted_78 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_79 = { class: "col" }
const _hoisted_80 = { class: "d-flex flex-column gap-1" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Status:", -1))
const _hoisted_82 = { class: "row mb-1" }
const _hoisted_83 = { class: "col" }
const _hoisted_84 = { class: "d-flex flex-column gap-1" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Data do reporte:", -1))
const _hoisted_86 = { class: "col" }
const _hoisted_87 = { class: "d-flex flex-column gap-1" }
const _hoisted_88 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col" }
const _hoisted_91 = { class: "d-flex flex-column gap-1" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Resolução do problema:", -1))
const _hoisted_93 = {
  key: 1,
  class: "card p-4"
}
const _hoisted_94 = { class: "container px-0" }
const _hoisted_95 = { class: "row gap-2 m-0" }
const _hoisted_96 = { class: "col p-0" }
const _hoisted_97 = { class: "card flex-row p-3 gap-2 align-items-center" }
const _hoisted_98 = {
  class: "p-3 rounded",
  style: {"background-color":"#f9f9f9","height":"fit-content","position":"relative"}
}
const _hoisted_99 = {
  key: 0,
  class: "icon-notification"
}
const _hoisted_100 = /*#__PURE__*/_createStaticVNode("<svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-8be7886c><g clip-path=\"url(#clip0_666_870)\" data-v-8be7886c><path opacity=\"0.3\" d=\"M21.6667 11.6668C21.6667 7.06266 16.8177 3.3335 10.8333 3.3335C4.84896 3.3335 0 7.06266 0 11.6668C0 13.4533 0.734375 15.0991 1.97917 16.4585C1.28125 18.0314 0.130208 19.2814 0.114583 19.297C0 19.4168 -0.03125 19.5939 0.0364583 19.7502C0.104167 19.9064 0.25 20.0002 0.416667 20.0002C2.32292 20.0002 3.90104 19.3595 5.03646 18.6981C6.71354 19.5158 8.69792 20.0002 10.8333 20.0002C16.8177 20.0002 21.6667 16.271 21.6667 11.6668ZM28.0208 23.1252C29.2656 21.771 30 20.12 30 18.3335C30 14.8491 27.2135 11.8647 23.2656 10.62C23.3125 10.9637 23.3333 11.3127 23.3333 11.6668C23.3333 17.1825 17.724 21.6668 10.8333 21.6668C10.2708 21.6668 9.72396 21.6252 9.18229 21.5679C10.8229 24.5627 14.6771 26.6668 19.1667 26.6668C21.3021 26.6668 23.2865 26.1877 24.9635 25.3647C26.099 26.0262 27.6771 26.6668 29.5833 26.6668C29.75 26.6668 29.901 26.5679 29.9635 26.4168C30.0312 26.2658 30 26.0887 29.8854 25.9637C29.8698 25.9481 28.7188 24.7033 28.0208 23.1252Z\" fill=\"#203972\" data-v-8be7886c></path><path d=\"M21.6667 11.6668C21.6667 7.06266 16.8177 3.3335 10.8333 3.3335C4.84896 3.3335 0 7.06266 0 11.6668C0 13.4533 0.734375 15.0991 1.97917 16.4585C1.28125 18.0314 0.130208 19.2814 0.114583 19.297C0 19.4168 -0.03125 19.5939 0.0364583 19.7502C0.104167 19.9064 0.25 20.0002 0.416667 20.0002C2.32292 20.0002 3.90104 19.3595 5.03646 18.6981C6.71354 19.5158 8.69792 20.0002 10.8333 20.0002C16.8177 20.0002 21.6667 16.271 21.6667 11.6668Z\" fill=\"#203972\" data-v-8be7886c></path></g><defs data-v-8be7886c><clipPath id=\"clip0_666_870\" data-v-8be7886c><rect width=\"30\" height=\"30\" fill=\"white\" data-v-8be7886c></rect></clipPath></defs></svg>", 1)
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "m-0 fs-6" }, " Chat completo "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "fs-9",
    style: {"color":"#B5B5C3","line-height":"1.2"}
  }, " Veja o histórico completo de conversas do cliente com o suporte. ")
], -1))
const _hoisted_102 = { class: "d-flex align-items-center gap-2" }
const _hoisted_103 = { class: "col p-0" }
const _hoisted_104 = { class: "card flex-row p-3 gap-2 align-items-center" }
const _hoisted_105 = /*#__PURE__*/_createStaticVNode("<div class=\"p-3 rounded\" style=\"background-color:#f9f9f9;height:fit-content;\" data-v-8be7886c><svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-8be7886c><path opacity=\"0.3\" d=\"M20.625 26.25V28.5938C20.625 29.3704 19.9954 30 19.2188 30H3.28125C2.50459 30 1.875 29.3704 1.875 28.5938V7.03125C1.875 6.25459 2.50459 5.625 3.28125 5.625H7.5V22.9688C7.5 24.7781 8.97193 26.25 10.7812 26.25H20.625ZM20.625 6.09375V0H10.7812C10.0046 0 9.375 0.62959 9.375 1.40625V22.9688C9.375 23.7454 10.0046 24.375 10.7812 24.375H26.7188C27.4954 24.375 28.125 23.7454 28.125 22.9688V7.5H22.0312C21.2578 7.5 20.625 6.86719 20.625 6.09375ZM27.7131 4.27564L23.8494 0.411855C23.5856 0.14815 23.228 1.94998e-06 22.855 0L22.5 0V5.625H28.125V5.26998C28.125 4.89704 27.9769 4.53936 27.7131 4.27564Z\" fill=\"#203972\" data-v-8be7886c></path><path d=\"M20.625 6.09375V0H10.7812C10.0046 0 9.375 0.62959 9.375 1.40625V22.9688C9.375 23.7454 10.0046 24.375 10.7812 24.375H26.7188C27.4954 24.375 28.125 23.7454 28.125 22.9688V7.5H22.0312C21.2578 7.5 20.625 6.86719 20.625 6.09375ZM27.7131 4.27564L23.8494 0.411855C23.5856 0.14815 23.228 1.94998e-06 22.855 0L22.5 0V5.625H28.125V5.26998C28.125 4.89704 27.9769 4.53936 27.7131 4.27564Z\" fill=\"#203972\" data-v-8be7886c></path></svg></div><div style=\"flex-grow:1;\" data-v-8be7886c><h4 class=\"m-0 fs-6\" data-v-8be7886c> Tickets Semelhantes </h4><span class=\"fs-9\" style=\"color:#B5B5C3;line-height:1.2;\" data-v-8be7886c> Consultar o problema e a solução de tickets semelhantes a este. </span></div>", 2)
const _hoisted_107 = { class: "d-flex align-items-center gap-2" }
const _hoisted_108 = {
  key: 0,
  class: "d-flex flex-column gap-3 p-0"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-0 m-0 subtitle" }, "Comentários", -1))
const _hoisted_110 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_111 = {
  class: "d-flex p-3 mt-2 rounded",
  style: {"border-top":"0.5px solid var(--cor_background_2)","background":"var(--cor_background_1) !important"}
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center ps-0 pe-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"54px","height":"48px","border-radius":"50%"},
    src: "https://t3.ftcdn.net/jpg/05/17/79/88/360_F_517798849_WuXhHTpg2djTbfNf0FQAjzFEoluHpnct.jpg",
    alt: ""
  })
], -1))
const _hoisted_113 = {
  class: "p-0 w-100 d-flex flex-column gap-3",
  style: {"overflow":"auto"}
}
const _hoisted_114 = { class: "textarea-container position-relative" }
const _hoisted_115 = ["disabled"]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M22.5775 13.3851L8.82801 5.25655C7.71087 4.59642 6 5.23702 6 6.86977V13L18 14.9964L6 16.6116V23.123C6 24.5878 7.58978 25.4706 8.82801 24.7362L22.5775 16.6116C23.804 15.8889 23.8079 14.1078 22.5775 13.3851Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_117 = [
  _hoisted_116
]
const _hoisted_118 = { class: "d-flex py-2" }
const _hoisted_119 = {
  enctype: "multipart/form-data",
  novalidate: ""
}
const _hoisted_120 = { class: "dropbox" }
const _hoisted_121 = { class: "d-flex gap-3" }
const _hoisted_122 = ["onClick"]
const _hoisted_123 = /*#__PURE__*/_createStaticVNode("<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-8be7886c><g clip-path=\"url(#clip0_4401_2273)\" data-v-8be7886c><path d=\"M2.5 18.125C2.5 18.6223 2.69754 19.0992 3.04917 19.4508C3.40081 19.8025 3.87772 20 4.375 20H15.625C16.1223 20 16.5992 19.8025 16.9508 19.4508C17.3025 19.0992 17.5 18.6223 17.5 18.125V5.00001H2.5V18.125ZM13.125 8.12501C13.125 7.95925 13.1908 7.80028 13.3081 7.68306C13.4253 7.56585 13.5842 7.50001 13.75 7.50001C13.9158 7.50001 14.0747 7.56585 14.1919 7.68306C14.3092 7.80028 14.375 7.95925 14.375 8.12501V16.875C14.375 17.0408 14.3092 17.1997 14.1919 17.3169C14.0747 17.4342 13.9158 17.5 13.75 17.5C13.5842 17.5 13.4253 17.4342 13.3081 17.3169C13.1908 17.1997 13.125 17.0408 13.125 16.875V8.12501ZM9.375 8.12501C9.375 7.95925 9.44085 7.80028 9.55806 7.68306C9.67527 7.56585 9.83424 7.50001 10 7.50001C10.1658 7.50001 10.3247 7.56585 10.4419 7.68306C10.5592 7.80028 10.625 7.95925 10.625 8.12501V16.875C10.625 17.0408 10.5592 17.1997 10.4419 17.3169C10.3247 17.4342 10.1658 17.5 10 17.5C9.83424 17.5 9.67527 17.4342 9.55806 17.3169C9.44085 17.1997 9.375 17.0408 9.375 16.875V8.12501ZM5.625 8.12501C5.625 7.95925 5.69085 7.80028 5.80806 7.68306C5.92527 7.56585 6.08424 7.50001 6.25 7.50001C6.41576 7.50001 6.57473 7.56585 6.69194 7.68306C6.80915 7.80028 6.875 7.95925 6.875 8.12501V16.875C6.875 17.0408 6.80915 17.1997 6.69194 17.3169C6.57473 17.4342 6.41576 17.5 6.25 17.5C6.08424 17.5 5.92527 17.4342 5.80806 17.3169C5.69085 17.1997 5.625 17.0408 5.625 16.875V8.12501ZM18.125 1.25001H13.4375L13.0703 0.519538C12.9925 0.363372 12.8727 0.232008 12.7243 0.140225C12.576 0.0484421 12.4049 -0.00011828 12.2305 6.84872e-06H7.76562C7.59155 -0.000662313 7.42082 0.047717 7.27297 0.139602C7.12513 0.231487 7.00615 0.363161 6.92969 0.519538L6.5625 1.25001H1.875C1.70924 1.25001 1.55027 1.31585 1.43306 1.43307C1.31585 1.55028 1.25 1.70925 1.25 1.87501L1.25 3.12501C1.25 3.29077 1.31585 3.44974 1.43306 3.56695C1.55027 3.68416 1.70924 3.75001 1.875 3.75001H18.125C18.2908 3.75001 18.4497 3.68416 18.5669 3.56695C18.6842 3.44974 18.75 3.29077 18.75 3.12501V1.87501C18.75 1.70925 18.6842 1.55028 18.5669 1.43307C18.4497 1.31585 18.2908 1.25001 18.125 1.25001Z\" fill=\"#ED2B46\" data-v-8be7886c></path></g><defs data-v-8be7886c><clipPath id=\"clip0_4401_2273\" data-v-8be7886c><rect width=\"20\" height=\"20\" fill=\"white\" data-v-8be7886c></rect></clipPath></defs></svg>", 1)
const _hoisted_124 = [
  _hoisted_123
]
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20 5.625V16.875C20 17.9102 19.1602 18.75 18.125 18.75H1.875C0.839844 18.75 0 17.9102 0 16.875V5.625C0 4.58984 0.839844 3.75 1.875 3.75H5.3125L5.79297 2.46484C6.06641 1.73437 6.76562 1.25 7.54688 1.25H12.4492C13.2305 1.25 13.9297 1.73437 14.2031 2.46484L14.6875 3.75H18.125C19.1602 3.75 20 4.58984 20 5.625ZM14.6875 11.25C14.6875 8.66406 12.5859 6.5625 10 6.5625C7.41406 6.5625 5.3125 8.66406 5.3125 11.25C5.3125 13.8359 7.41406 15.9375 10 15.9375C12.5859 15.9375 14.6875 13.8359 14.6875 11.25ZM13.4375 11.25C13.4375 13.1445 11.8945 14.6875 10 14.6875C8.10547 14.6875 6.5625 13.1445 6.5625 11.25C6.5625 9.35547 8.10547 7.8125 10 7.8125C11.8945 7.8125 13.4375 9.35547 13.4375 11.25Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_126 = [
  _hoisted_125
]
const _hoisted_127 = {
  class: "d-flex flex-column gap-2",
  style: {"max-height":"35rem","overflow":"auto"}
}
const _hoisted_128 = {
  key: 1,
  class: "card p-4"
}
const _hoisted_129 = { class: "d-flex flex-column gap-2" }
const _hoisted_130 = { class: "dialog-footer" }
const _hoisted_131 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Comments = _resolveComponent("Comments")!
  const _component_ModalTickets = _resolveComponent("ModalTickets")!
  const _component_ModalChat = _resolveComponent("ModalChat")!
  const _component_ModalJira = _resolveComponent("ModalJira")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_Title, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.id_ticket ? `Editando ticket: TCK-${_ctx.id_ticket}` : "Criar novo ticket"), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          text: "Voltar",
          type: "button",
          onClick: _ctx.goBack
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.id_ticket)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_Button, {
                disabled: !_ctx.isOwner,
                text: "Excluir ticket",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmExcluirTicket = true))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.optionsSaving)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              variant: "secondary",
              text: "Salvar",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.centerDialogVisible = true))
            }, {
              default: _withCtx(() => [
                (_ctx.loadCreate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              variant: "secondary",
              text: "Salvar",
              onClick: _ctx.createTicket
            }, {
              default: _withCtx(() => [
                (_ctx.loadCreate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
              ]),
              _: 1
            }, 8, ["onClick"]))
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", null, [
              _createVNode(_component_Title, { description: "Preencha os detalhes sobre o cliente" }, {
                default: _withCtx(() => [
                  _createTextVNode("Informações do cliente")
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_24,
          (!_ctx.isLoadingTicket)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _withDirectives((_openBlock(), _createBlock(_component_el_input, {
                        modelValue: _ctx.infoClient.cnpj,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.infoClient.cnpj) = $event)),
                        placeholder: "Digite...",
                        maxlength: "18"
                      }, {
                        suffix: _withCtx(() => [
                          _createElementVNode("div", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getStore())),
                            class: "me-2",
                            style: {"cursor":"pointer"},
                            title: "Clique para pesquisar"
                          }, _hoisted_31)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])), [
                        [_directive_maska, { mask: '##.###.###/####-##' }]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_el_select, {
                        clearable: "",
                        modelValue: _ctx.infoClient.store_name,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.infoClient.store_name) = $event)),
                        filterable: "",
                        "allow-create": "",
                        placeholder: "Selecione...",
                        disabled: Array.isArray(_ctx.arrayStores) && _ctx.arrayStores.length ? false : true
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayStores, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.key,
                              label: item.nomeFantasia,
                              value: item.nomeFantasia
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.infoClient.store_manager,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.infoClient.store_manager) = $event)),
                        clearable: "",
                        placeholder: "Digite..."
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.infoClient.solicitante,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.infoClient.solicitante) = $event)),
                        clearable: "",
                        placeholder: "Digite..."
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _withDirectives(_createVNode(_component_el_input, {
                        modelValue: _ctx.infoClient.store_contact,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.infoClient.store_contact) = $event)),
                        clearable: "",
                        placeholder: "Digite...",
                        maxlength: "15"
                      }, null, 8, ["modelValue"]), [
                        [_directive_maska, { mask: _ctx.infoClient.store_contact !== null && _ctx.infoClient.store_contact!== 'undefined' ? (`${ _ctx.infoClient.store_contact.replace(/[^\d]+/g, '').length < 11 ? '(##) ####-####' : '(##) # ####-####'}`) : '(##) # ####-####' }]
                      ])
                    ])
                  ])
                ]),
                (_ctx.id_project != 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.infoClient.erp,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.infoClient.erp) = $event)),
                            placeholder: "Digite..."
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _hoisted_51,
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.infoClient.possui_conecta,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.infoClient.possui_conecta) = $event)),
                            placeholder: "Selecione"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: 'sim',
                                value: "1"
                              }),
                              _createVNode(_component_el_option, {
                                label: 'não',
                                value: "0"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createVNode(_component_el_skeleton, {
                  animated: "",
                  rows: 5
                })
              ]))
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_component_Title, { description: "Descreva mais detalhes sobre o problema" }, {
                default: _withCtx(() => [
                  _createTextVNode("Informações do problema")
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_57,
          (!_ctx.isLoadingTicket)
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createVNode(_component_el_select, {
                      onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.findForm())),
                      modelValue: _ctx.infoProblema.id_category,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.infoProblema.id_category) = $event)),
                      disabled: _ctx.isDisabled || (Array.isArray(_ctx.arrayCategory) && _ctx.arrayCategory.length ? false : true),
                      placeholder: "Selecione...",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayCategory, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  (_ctx.ativaSelectStatus)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.infoProblema.id_status,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.infoProblema.id_status) = $event)),
                            placeholder: "Selecione..."
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayStatus, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createVNode(_component_el_input, {
                            clearable: "",
                            modelValue: _ctx.infoProblema.email,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.infoProblema.email) = $event)),
                            placeholder: "example@mail.com"
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.openForm)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_67, [
                      _createElementVNode("li", _hoisted_68, [
                        _createElementVNode("span", null, [
                          _createTextVNode("Titulo do ticket: "),
                          (_ctx.jiraRequired)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_69, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_el_input, {
                          clearable: "",
                          modelValue: _ctx.infoProblema.title,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.infoProblema.title) = $event)),
                          placeholder: "Digite..."
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("li", _hoisted_70, [
                        _createElementVNode("span", null, [
                          _createTextVNode("Descrição do problema: "),
                          (_ctx.jiraRequired)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_71, "*"))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_el_input, {
                          clearable: "",
                          modelValue: _ctx.infoProblema.description,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.infoProblema.description) = $event)),
                          rows: 4,
                          type: "textarea",
                          placeholder: "Digite..."
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _hoisted_73,
                        _createVNode(_component_el_input, {
                          clearable: "",
                          modelValue: _ctx.infoProblema.email,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.infoProblema.email) = $event)),
                          placeholder: "example@mail.com"
                        }, null, 8, ["modelValue"])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formDinamico.campos, (field, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "col-6 mb-2 p-2",
                          key: index
                        }, [
                          (field.type === 'input')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", null, _toDisplayString(field.label), 1),
                                _createVNode(_component_el_input, {
                                  clearable: "",
                                  modelValue: field.value,
                                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                  placeholder: "Digite..."
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ], 64))
                            : _createCommentVNode("", true),
                          (field.type === 'date')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("span", null, _toDisplayString(field.label), 1),
                                _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      modelValue: field.value,
                                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                      type: "date",
                                      format: "DD/MM/YYYY",
                                      class: "w-100",
                                      placeholder: "Defina uma data"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1032, ["locale"])
                              ], 64))
                            : _createCommentVNode("", true),
                          (field.type === 'textarea')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createElementVNode("span", null, _toDisplayString(field.label), 1),
                                _createVNode(_component_el_input, {
                                  clearable: "",
                                  modelValue: field.value,
                                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                  type: "textarea",
                                  placeholder: "Digite..."
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ], 64))
                            : _createCommentVNode("", true),
                          (
                      field.type === 'select' &&
                      Array.isArray(field.options) &&
                      field.options.length
                    )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createElementVNode("span", null, _toDisplayString(field.label), 1),
                                _createVNode(_component_el_select, {
                                  modelValue: field.value,
                                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                  placeholder: "Selecione..."
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transformArrayDeObjetos(field.options as string[]), (item, key) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: key,
                                        value: item.value,
                                        label: item.label
                                      }, null, 8, ["value", "label"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("span", null, [
                              _createTextVNode("Resumo: "),
                              (_ctx.jiraRequired)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_78, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.infoProblema.title,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.infoProblema.title) = $event)),
                              placeholder: "Digite..."
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _hoisted_81,
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.infoProblema.id_status,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.infoProblema.id_status) = $event)),
                              placeholder: "Selecione...",
                              disabled: (Array.isArray(_ctx.arrayStatus) && _ctx.arrayStatus.length ? false : true)
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayStatus, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _hoisted_85,
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.infoProblema.report_date,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.infoProblema.report_date) = $event)),
                              type: "date",
                              placeholder: "Pick a day",
                              format: "DD/MM/YYYY"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("span", null, [
                              _createTextVNode("Descrição do problema: "),
                              (_ctx.jiraRequired)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_88, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.infoProblema.description,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.infoProblema.description) = $event)),
                              rows: 4,
                              type: "textarea",
                              placeholder: "Digite..."
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _hoisted_92,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.infoProblema.resolution,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.infoProblema.resolution) = $event)),
                              rows: 4,
                              type: "textarea",
                              placeholder: "Digite..."
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_93, [
                _createVNode(_component_el_skeleton, {
                  animated: "",
                  rows: 8
                })
              ]))
        ]),
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  (_ctx.id_ticket && _ctx.notifications[_ctx.id_ticket.toString()])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString(_ctx.notifications[_ctx.id_ticket.toString()]), 1))
                    : _createCommentVNode("", true),
                  _hoisted_100
                ]),
                _hoisted_101,
                _createElementVNode("div", _hoisted_102, [
                  _createVNode(_component_Button, {
                    variant: "primary",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.openModal('modalChat'), _ctx.resetNotification(_ctx.id_ticket)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", _hoisted_104, [
                _hoisted_105,
                _createElementVNode("div", _hoisted_107, [
                  _createVNode(_component_Button, {
                    variant: "primary",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.id_ticket)
      ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
          _hoisted_109,
          (!_ctx.isLoadingComments)
            ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _hoisted_112,
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("div", _hoisted_114, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.comment.comentario,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.comment.comentario) = $event)),
                        rows: 4,
                        type: "textarea",
                        placeholder: "Digite...",
                        id: "text-area-comments",
                        resize: "none"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("button", {
                        disabled: _ctx.clickedSendComment || !_ctx.comment.comentario,
                        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.createComment && _ctx.createComment(...args))),
                        class: "btn btn-light-danger p-1 m-2 position-absolute bottom-0 end-0",
                        style: {"cursor":"pointer"},
                        id: "sendComment"
                      }, _hoisted_117, 8, _hoisted_115)
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("form", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _createElementVNode("input", {
                            type: "file",
                            ref: "fileInput",
                            multiple: "",
                            id: "input-file",
                            name: "fileUpload",
                            onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.filesChange && _ctx.filesChange(...args))),
                            accept: "image/*"
                          }, null, 544)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_121, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urlImagesToPreview, (url, key) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: url,
                            style: {"position":"relative"}
                          }, [
                            _createVNode(_component_el_image, {
                              class: "rounded",
                              style: {"width":"100px","height":"100px","cursor":"pointer"},
                              src: url,
                              "zoom-rate": 1.2,
                              "max-scale": 7,
                              "min-scale": 0.2,
                              "preview-src-list": _ctx.urlImagesToPreview,
                              "initial-index": key,
                              fit: "cover"
                            }, null, 8, ["src", "preview-src-list", "initial-index"]),
                            _createElementVNode("div", {
                              style: {"position":"absolute","bottom":"10px","right":"4px","cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.deletePreviewImage(key))
                            }, _hoisted_124, 8, _hoisted_122)
                          ]))
                        }), 128)),
                        _createElementVNode("div", {
                          onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.openInput && _ctx.openInput(...args))),
                          style: {"cursor":"pointer"},
                          class: "d-flex justify-content-center align-items-center"
                        }, _hoisted_126)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_127, [
                  (_ctx.arrayComments.length > 0)
                    ? (_openBlock(), _createBlock(_component_Comments, {
                        key: 0,
                        arrayComments: _ctx.arrayComments
                      }, null, 8, ["arrayComments"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_128, [
                _createVNode(_component_el_skeleton, {
                  animated: "",
                  rows: 5
                })
              ]))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalTickets),
    _createVNode(_component_ModalChat),
    _createVNode(_component_ModalJira, {
      onReceiveConfigJira: _cache[27] || (_cache[27] = ($event: any) => (_ctx.receiveConfigJira($event)))
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.centerDialogVisible,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
      title: "Atenção",
      style: {"width":"10rem"},
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_130, [
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.centerDialogVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancelar")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_129, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-light-danger",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.sendToJira = true, _ctx.createTicket()))
          }, "Criar ticket e card no Jira"),
          _createElementVNode("button", {
            class: "btn btn-sm btn-light-danger",
            onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.createTicket && _ctx.createTicket(...args)))
          }, "Criar somente ticket")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.confirmExcluirTicket,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.confirmExcluirTicket) = $event)),
      title: "Deseja excluir o ticket?",
      style: {"width":"10rem"},
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_131, [
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.confirmExcluirTicket = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancelar")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.confirmExcluirTicket = false, _ctx.deleteTicket(_ctx.id_ticket)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Confirmar ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}